import { useAuth } from '../auth/AuthContext';
import { NotAuthorized } from '../components/NotAuthorized';

export function NotAuthorizedPage() {
  const { logout, user } = useAuth();
  const claims = (user?.account?.idTokenClaims ?? undefined) as Record<string, unknown> | undefined;
  return (
    <NotAuthorized
      onSignOut={() => void logout()}
      signedInAs={user?.email || user?.displayName || user?.account?.username}
      claims={claims}
    />
  );
}
